import React from "react";
import ReactPlayer from "react-player";

import "./css/partrocinadores.css";

export default function Patrocinadores() {

    const patrocinadores = [
        {
            nombre: "CFIS-UPC",
            tipo: "Colaborador en la organización de la final presencial y acogedor del evento",
            parrafos: [
                <>
                    <p>
                        El CFIS, Centro de Formación Interdisciplinaria Superior, de la Universitat Politècnica de Catalunya (UPC) tiene la misión de captar cada año 40 estudiantes con altas capacidades en ciencia, 
                        tecnología y matemáticas para potenciar su talento y su proyección internacional. Estas personas estudian dos grados simultáneamente en 4 años y medio en el marco de una oferta flexible entre 
                        10 titulaciones de la UPC, participan en programas de formación adicional en instituciones de investigación y en empresas, y pasan un semestre investigando en las mejores universidades y centros 
                        de investigación en todo el mundo para realizar su trabajo de fin de grado. Todas ellas reciben varias ayudas económicas como becas de matrículas, ayudas del programa de movilidad internacional, o 
                        ayudas de residencia.
                    </p>
                </>,
            ],
            link: "https://cfis.upc.edu/es/el-centro",
            italics: "El CFIS ha acogido la final presencial desde el inicio de la OIFem y va a acoger también la final de 2024."
        },
        {
            nombre: "Spise Misu",
            tipo: "Patrocinador diamante",
            video: "https://www.youtube.com/watch?v=e2PyNEg3OpQ&t=1s",
            parrafos: [
                <>
                    <p>
                        La empresa se fundó para proporcionar la posibilidad de crear software que cumpla con la Directiva 95/46/CE, también conocida como Reglamento General de Protección de Datos o simplemente RGPD de 
                        la UE, por medios técnicos.
                    </p>
                </>,
                <>
                    <p>
                        Mientras el <a href="https://uniprocess.org/" target="_blank" rel="noopener noreferrer">concepto</a> se encuentra aún en etapa de investigación básica, la empresa proporciona servicios de consultoría 
                        en diversos áreas.
                    </p>
                </>
            ],
            italics: "Patrocinador de las sudaderas del equipo para la EGOI 2023 celebrada en Lund, Suecia",
            link: "https://spisemisu.com/"
        },
        {
            nombre: "G-Research",
            tipo: "Patrocinador diamante",
            parrafos: [
                <>
                    <p>
                        G-Research es una empresa líder en tecnología e investigación cuantitativa. Nos apasiona la intersección de las finanzas, la tecnología y el futuro. Ofrecemos una cultura dinámica, flexible y 
                        altamente estimulante donde se cultivan y recompensan las ideas líderes en el mundo. Estamos orgullosos de emplear a algunas de las mejores personas en su campo y de fomentar su talento en nuestro 
                        entorno de trabajo colaborativo. Nuestros investigadores utilizan las últimas técnicas científicas y métodos estadísticos avanzados para predecir movimientos en los mercados financieros globales. 
                        Utilizamos una metodología científica rigurosa para analizar un extenso ecosistema de datos, extrayendo conocimientos profundos de conjuntos de datos verdaderamente masivos. Nuestra plataforma 
                        permite a nuestros investigadores probar, modelar y obtener resultados instantáneos. Luego empleamos técnicas de optimización de última generación para maximizar el valor de cada idea. Nuestros 
                        investigadores tienen un desafío: refutar cada día la hipótesis del mercado eficiente. Esto requiere que aprovechen nuestra enorme potencia informática y utilicen técnicas de aprendizaje automático 
                        de última generación (publicadas en conferencias recientes o desarrolladas íntegramente internamente), ya que los métodos de los libros de texto no superarán a la competencia.
                    </p>
                </>,
                <>
                    <p>
                        Nuestra cultura es colaborativa e intelectual. La mayoría de nuestros investigadores provienen de doctorados o posdoctorados de las principales instituciones mundiales y sus trabajos se han publicado 
                        en las conferencias más prestigiosas del mundo. Nuestros investigadores cuantitativos y profesionales del aprendizaje automático tienen un historial de logros académicos en matemáticas, física, aprendizaje 
                        automático, informática o ingeniería.
                    </p>
                </>
            ],
            italics: "Patrocinador de la IV OIFem (2024)."
        },
        {
            nombre: "Qualcomm",
            tipo: "Patrocinador diamante",
            parrafos: [
                <>
                    <p>
                        Qualcomm is a leading company in Wireless innovation, with key contributions to all generations of Wireless communication systems, from CDMA to 5G/6G, and across platforms such as Bluetooth and 
                        Wi-Fi. Qualcomm is driving research on Extended Reality (XR) and AI, computing processors, and automotive verticals (on safety and connected vehicles).
                    </p>
                </>
            ],
            italics: "Patrocinador de la IV OIFem (2024)."
        },
        {
            nombre: "BBVA",
            tipo: "Patrocinador diamante",
            parrafos: [
                <>
                    <p>Próximamente.</p>
                </>
            ]
        }
    ];

    return (
        <div>
            <div className="destacado">
                <h1>Patrocinadores</h1>
                <p>
                    La OIFem nació en 2020 y desde el principio hemos recibido mucha ayuda por parte de nuestros patrocinadores. En esta sección conocerás más información sobre ellos y sus 
                    actividades.
                </p>
            </div>
            
            {patrocinadores.map((patro, index) => (
                <div key={index} className="patrocinador-holder">
                    <h2>{patro.nombre}</h2>
                    <p><b>{patro.tipo}</b></p>

                    {patro.video !== undefined && <div className="video-holder">
                        <ReactPlayer 
                            url={patro.video}
                            controls
                            width="100%"
                            height="100%"
                        />   
                    </div>}
                    
                    {patro.parrafos.map((parrafo, i) => (
                        <div key={i} className="parrafo">{parrafo}</div>
                    ))}
                    {patro.link !== undefined && <p>Para más información: <a href={patro.link} target="_blank" rel="noopener noreferrer">{patro.link}</a></p>}
                    {patro.italics !== undefined && <div><i>{patro.italics}</i></div>}
                </div>
            ))}
        </div>
    );
}